import type { ComponentPropsWithoutRef, ReactNode } from "react";

import { cx } from "class-variance-authority";

import * as theme from "./SidebarBrandButton.css";

export interface SidebarBrandButtonProps extends Omit<
    ComponentPropsWithoutRef<"button">,
    "type" | "children"
> {
    label: string;
    children: ReactNode;
}

export function SidebarBrandButton({
    label,
    children,
    className,
    ...rest
}: SidebarBrandButtonProps) {
    return (
        <button
            type="button"
            data-slot="sidebar-brand-button"
            aria-label={label}
            className={cx(theme.root, className)}
            {...rest}
        >
            <span className={theme.glyph}>{children}</span>
        </button>
    );
}
